import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, catchError, map, Observable, of, tap } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})
export class FeaturesService {
  private apiUrl = `${environment.apiUrl}/features`;
  private features$ = new BehaviorSubject<Record<string, boolean>>({});

  constructor(private http: HttpClient) { }

  /**
   * Fetches the latest feature flags from the server
   */
  refreshFeatures(): Observable<Record<string, boolean>> {
    return this.http.get<Record<string, boolean>>(this.apiUrl).pipe(
      tap(features => this.features$.next(features)),
      catchError(() => {
        console.error("Could not load feature flags");
        return of({}); // Return empty so app still boots
      })
    );
  }

  /**
   * Returns an observable indicating if a specific feature is enabled
   * @param key The feature flag key
   */
  isEnabled(key: string): Observable<boolean> {
    return this.features$.asObservable().pipe(
      map(features => !!features[key])
    );
  }

  /**
   * Snapshot check of a feature flag
   */
  isEnabledSync(key: string): boolean {
    return !!this.features$.value[key];
  }
}